import { motion } from "framer-motion";
import React from "react";
import { useBreakpoint } from "~/design-system/hooks";
import { SafeArea } from "~/design-system/SafeArea";
import { Box } from "../../Box";
import { Placeholder } from "../../Placeholder";

const Header = () => {
  return (
    <Box
      display="flex"
      justifyContent="flexStart"
      alignItems="center"
      width="full"
      marginBottom="medium"
      marginTop="medium"
    >
      <Placeholder height="xsmall" width="small" borderRadius="small" />
      <Placeholder
        marginLeft="small"
        height="xsmall"
        width="full"
        borderRadius="small"
      />
      <Placeholder
        marginLeft="small"
        height="xsmall"
        width="large"
        borderRadius="small"
      />
    </Box>
  );
};

const FileRow = () => {
  const { breakpoint } = useBreakpoint();

  return (
    <Box
      display="flex"
      justifyContent="flexStart"
      alignItems="center"
      width="full"
      marginBottom="small"
      marginTop="medium"
    >
      <Placeholder
        flexGrow={1}
        flexShrink={0}
        marginRight="small"
        height="xsmall"
        width="xsmall"
        borderRadius="small"
      />
      <Placeholder
        flexGrow={1}
        flexShrink={0}
        marginRight="small"
        height="xsmall"
        width="xsmall"
        borderRadius="small"
      />
      <Placeholder height="xsmall" width="full" borderRadius="small" />
      {!(breakpoint === "mobile") && (
        <>
          {!!Math.round(Math.random()) && (
            <Placeholder
              marginLeft="small"
              height="xsmall"
              width="large"
              borderRadius="small"
            />
          )}
          {!!Math.round(Math.random()) && (
            <Placeholder
              marginLeft="small"
              height="xsmall"
              width="xsmall"
              borderRadius="full"
              flexGrow={1}
              flexShrink={0}
            />
          )}
          {!!Math.round(Math.random()) && (
            <Placeholder
              marginLeft="small"
              height="xsmall"
              width="large"
              borderRadius="small"
            />
          )}
        </>
      )}
    </Box>
  );
};

const FilesListSkeleton = () => {
  const { breakpoint } = useBreakpoint();

  const MIN_ROWS = 5;
  const MAX_ROWS = 12;

  const randomArray = Array.from({
    length: Math.floor(Math.random() * MAX_ROWS) + MIN_ROWS,
  });

  return (
    <motion.div
      style={{
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "flex-start",
        width: "100%",
      }}
      initial={{ opacity: 0.4 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.6,
        ease: "easeIn",
        repeat: Infinity,
        repeatType: "mirror",
      }}
    >
      <SafeArea top />
      {!(breakpoint === "mobile") && <Header />}
      {randomArray.map((el, index) => {
        return <FileRow key={index} />;
      })}
    </motion.div>
  );
};

export { FilesListSkeleton };
